import { gcj02ToBd09ii } from "./utils"
let authenticationJsApiList = []
let authUrl;
export default {
  type: "wechat",
  isEnv() {
    return dsf.client.weixin();
  },
  init(opt = {}, ref) {
    return new Promise((resolve, reject) => {
      try {
        let { sdkUrl } = opt;
        if (!sdkUrl) {
          throw "请传入wechat.sdkUrl";
        }
        dsf.http
          .importFiles(opt.sdkUrl)
          .then(([{ state }]) => {
            // 加载sdk
            if (!state) {
              console.error("wechat.js文件出错");
              reject(`${sdkUrl}文件出错`);
            }
            authenticationJsApiList = this.jsApiList;
            authUrl = opt.authUrl||'/api/wechat/auth/js/token';
            authentication()
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      } catch (error) {
        reject(error);
      }
    });
  },
  jsApiList: [
    "updateAppMessageShareData",
    "updateTimelineShareData",
    "onMenuShareTimeline",
    "onMenuShareAppMessage",
    "onMenuShareQQ",
    "onMenuShareWeibo",
    "onMenuShareQZone",
    "startRecord",
    "stopRecord",
    "onVoiceRecordEnd",
    "playVoice",
    "pauseVoice",
    "stopVoice",
    "onVoicePlayEnd",
    "uploadVoice",
    "downloadVoice",
    "chooseImage",
    "previewImage",
    "uploadImage",
    "downloadImage",
    "translateVoice",
    "getNetworkType",
    "openLocation",
    "getLocation",
    "hideOptionMenu",
    "showOptionMenu",
    "hideMenuItems",
    "showMenuItems",
    "hideAllNonBaseMenuItem",
    "showAllNonBaseMenuItem",
    "closeWindow",
    "scanQRCode",
    "chooseWXPay",
    "openProductSpecificView",
    "addCard",
    "chooseCard",
    "openCard",
  ],
  methods: {
    /**
     * 选择图片
     * @param options.count 选择数量， 默认1
     * @param options.sizeType 可以指定是原图还是压缩图，默认二者都有
     * @param options.sourceType 可以指定来源是相册还是相机，默认二者都有
     * @returns {*}
     */
    chooseImage(options = {}) {
      options = Object.assign(
        {
          count: 1,
          sizeType: ["original", "compressed"],
          sourceType: ["album", "camera"],
        },
        options
      );
      return new Promise((resolve, reject) => {
        wx.chooseImage({
          ...options,
          success: async function (res) {
            try {
              let arr = [],
                base64List = await localImgToBase64(res.localIds);
              for (let i = 0, l = base64List.length; i < l; i++) {
                let file = await createLocalImgFile(base64List[i]);
                arr.push(file);
              }
              resolve(arr);
            } catch (e) {
              reject(e);
            }
          },
          fail(err) {
            reject(err);
          },
        });
      });
    },
    /**
     * 预览图片
     * @param options.current 当前显示图片的http链接
     * @param options.urls 需要预览的图片http链接列表
     * @returns {*}
     */
    previewImage(options = {}) {
      options = Object.assign(
        {
          current: "",
          urls: [],
        },
        options
      );
      wx.previewImage(options);
      return Promise.resolve();
    },
    /**
     * 扫码
     * @param options.scanType 可以指定扫二维码还是一维码，默认二者都有
     * @returns {*}
     */
    scan: scan,
    /**
     * 获取地理位置接口
     * @param options.type 默认为wgs84的gps坐标
     */
    getLocation: getLocation,
    /**
     * 使用应用内置地图查看位置
     * @param options.latitude 纬度，浮点数，范围为90 ~ -90
     * @param options.longitude 经度，浮点数，范围为180 ~ -180
     * @param options.name 位置名
     * @param options.address 地址详情说明
     * @param options.scale 地图缩放级别,整型值,范围从1~28。默认为最大
     */
    openLocation(options = {}) {
      options = Object.assign(
        {
          latitude: 0,
          longitude: 0,
          scale: 18,
          name: "",
          address: "",
        },
        options
      );
      wx.openLocation(options);
      return Promise.resolve();
    },
    /**
     * 拨打电话
     * @param options
     * @param options.phoneNumber {string} 手机号码
     */
    callPhone(options = {}) {
      return new Promise((resolve, reject) => {
        try {
          if (!options.phoneNumber) throw "请传入phoneNumber电话号码";
          window.location.href = `tel:${options.phoneNumber}`;
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取用户详情
    getUserDetails() {
      return new Promise((resolve, reject) => {
        try {
          let data = {
            country: decodeURIComponent(dsf.session.get("country")),
            headImgUrl: decodeURIComponent(dsf.session.get("headImgUrl")),
            nickName: decodeURIComponent(dsf.session.get("nickName")),
            openid: decodeURIComponent(dsf.session.get("openId")),
            province: decodeURIComponent(dsf.session.get("province")),
            sex: decodeURIComponent(dsf.session.get("sex")),
            unionId: decodeURIComponent(dsf.session.get("unionId")),
          };
          let res = {
            openid: data.openid,
            name: data.nickName,
          };
          res["_" + this.$type] = data;
          resolve(res);
        } catch (err) {
          reject(err);
        }
      });
    },
    // 分享
    shareToMessage(opt) {
      try {
        let _opt = this._getFuncOpts(
          {
            url: "",
            title: "",
            content: "",
            image: "",
          },
          opt
        );
        if (!_opt.url) {
          throw "请传入url";
        }
        if (!_opt.title) {
          throw "请传入title";
        }
        let close = shareToMessageShowBox();
        return Promise.all([
          new Promise((resolve, reject) => {
            wx.updateTimelineShareData({
              title: _opt.title, // 分享标题
              link: _opt.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _opt.imgUrl, // 分享图标
              success: function (res) {
                // 设置成功
                resolve(res);
              },
              fail: function (err) {
                reject(err);
              },
            });
            resolve();
          }),
          new Promise((resolve, reject) => {
            wx.updateAppMessageShareData({
              title: _opt.title, // 分享标题
              desc: _opt.content, // 分享描述
              link: _opt.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: _opt.imgUrl, // 分享图标
              success: function (res) {
                // 设置成功
                resolve(res);
              },
              fail: function (err) {
                reject(err);
              },
            });
            resolve();
          }),
        ]);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 获取当前定位位置
    getGeolocation: getLocation,
    location: {
      getBD: getLocation,
    },
    camera: {
      scan: scan,
    },
  },
};

function createLocalImgFile(src) {
  let type = Object.prototype.toString.call(src);
  if (type == "[object String]") {
    return new Promise((resolve, reject) => {
      let obj = new Image();
      obj.onload = async () => {
        try {
          let file = await createLocalImgFile(obj);
          resolve(file);
        } catch (err) {
          reject(err);
        }
      };
      obj.onerror = (e) => {
        reject(e);
      };
      obj.src =
        src.indexOf("data:image") == 0 ? src : "data:image/jpeg;base64," + src;
    });
  }
  if (type == "[object HTMLImageElement]") {
    return new Promise((resolve, reject) => {
      let { width, height } = src;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(src, 0, 0, width, height);
      try {
        canvas.toBlob(
          (blob) => {
            blob.name = dsf.uuid(32) + ".jpg";
            resolve(blob);
          },
          "image/jpeg",
          0.8
        );
      } catch (e) {
        reject(e);
      }
    });
  }
  return Promise.reject(null);
}

function localImgToBase64(localIds) {
  return new Promise((resolve, reject) => {
    let fn = (i = 0, arr = []) => {
      if (i == localIds.length) {
        resolve(arr);
        return;
      }
      wx.getLocalImgData({
        localId: localIds[i],
        success: function (res) {
          arr.push(res.localData);
          fn(i + 1, arr);
        },
        error: function (err) {
          reject(err);
        },
      });
    };
    fn();
  });
}

function getLocation() {
  try {
    const fn = () => {
      return new Promise((resolve, reject) => {
        wx.getLocation({
          type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (data) => {
            const location = gcj02ToBd09ii({
              lng: data.longitude,
              lat: data.latitude,
            });
            let res = {
              type: "gcj02",
              lng: location.lng,
              lat: location.lat,
              longitude: location.lng,
              latitude: location.lat,
            };
            res["_" + this.$type] = data;
            resolve(res);
          },
          fail: function (err) {
            reject(err);
          },
          cancel: function (err) {
            reject(err);
          },
        });
      });
    };
    if (dsf.client.android()) {
      return authentication().then(() => {
        return fn();
      });
    } else {
      return fn();
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

function scan(opt = {}) {
  try {
    let _opt = this._getFuncOpts(
      {
        needResult: 1,
        scanType: ["qrCode", "barCode"],
      },
      opt
    );
    const fn = () => {
      return new Promise((resolve, reject) => {
        wx.scanQRCode({
          needResult: _opt.needResult, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: _opt.scanType, // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
            resolve((res && res.resultStr) || "");
          },
          fail: function (err) {
            reject(err);
          },
          complete: function (val) {},
        });
      });
    };
    if (dsf.client.android()) {
      return authentication().then(() => {
        return fn();
      });
    } else {
      return fn();
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

//鉴权
function authentication(jsApiList) {
  return new Promise((resolve, reject) => {
    dsf.http
      .get(authUrl, { url: window.encodeURIComponent(window.location.href) })
      .done((res) => {
        if (res.data.jsApiTicket) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: jsApiList || authenticationJsApiList, // 必填，需要使用的JS接口列表
          });
          wx.ready(function () {
            resolve(true);
          });
          wx.error(function (res) {
            reject(res);
          });
        }
      })
      .error((res) => {
        reject(res);
      });
  });
}

// 微信分享提示
function shareToMessageShowBox(text) {
  let box = $(`
  <div class="dsf-share-to-message-box">
    <div class="dsf-share-to-message-box-jiantou">
    →
    </div>
    <div class="dsf-share-to-message-box-text">
    ${text || "点击更多菜单，自行分享"}
    </div>
  </div>
`).appendTo($(document.body));
  box.click(() => box.remove());
  return function () {
    box.remove();
  };
}
